import posthog from "posthog-js";
import {
  attemptChunkLoadRecovery,
  type ChunkLoadRecoveryOutcome,
} from "@/lib/chunk-load-recovery";
import {
  attemptMismatchedDocumentRecovery,
  attemptRetiredDeploymentRecovery,
} from "@/lib/retired-deployment";

let exhaustionRecorded = false;

function recoveryContext(error: Error): Record<string, string> {
  return {
    error_message: error.message.slice(0, 200),
    pathname: window.location.pathname,
  };
}

export function recoverFromRetiredDeployment(
  error: Error,
): ChunkLoadRecoveryOutcome {
  const outcome = attemptChunkLoadRecovery(error, () => {
    posthog.capture("chunk_load_recoverable_error", recoveryContext(error));
  });
  if (outcome === "reloading") return outcome;
  if (outcome === "exhausted") {
    if (!exhaustionRecorded) {
      exhaustionRecorded = true;
      posthog.capture("chunk_load_recovery_exhausted", recoveryContext(error));
    }
    return outcome;
  }
  if (outcome !== "not_chunk_load_error") return outcome;

  const mismatchedDocument = attemptMismatchedDocumentRecovery(() => {
    posthog.capture("retired_deployment_reload", {
      ...recoveryContext(error),
      detected_by: "document_release",
    });
  });
  if (mismatchedDocument !== "not_chunk_load_error") return mismatchedDocument;

  void attemptRetiredDeploymentRecovery(() => {
    posthog.capture("retired_deployment_reload", {
      ...recoveryContext(error),
      detected_by: "serving_release",
    });
  });
  return outcome;
}
